import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { State } from '../../interfaces/state';
import { BaseModel } from './base-model';
import { License } from './license';
import { PrimaryTrade } from './primary-trade';
import { SubNationalDivision } from './sub-national-division';
import { TradeLicense } from './trade-license';
import { VendorTrade } from './vendor-trade';

export class PrimaryTradeLicenseRequirement extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static PrimaryTradeLicenseRequirementProperties: (
    | {
        property: keyof PrimaryTradeLicenseRequirement;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof PrimaryTradeLicenseRequirement;
        type: 'alias';
      }
    | {
        property: keyof PrimaryTradeLicenseRequirement;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'PrimaryTradeId', type: 'column', dataType: 'number' },
    { property: 'SubNationalDivisionId', type: 'column', dataType: 'number' },
    { property: 'state', type: 'column', dataType: 'string' },
    { property: 'isRequired', type: 'column', dataType: 'boolean' },
    { property: 'lookupURL', type: 'column', dataType: 'string' },
    { property: 'city', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'PrimaryTrade', model: 'PrimaryTrade', type: 'association' },
    {
      property: 'SubNationalDivision',
      model: 'SubNationalDivision',
      type: 'association'
    },
    { property: 'VendorTrade', model: 'VendorTrade', type: 'association' },
    { property: 'Licenses', model: 'License', type: 'association' },
    { property: 'TradeLicenses', model: 'TradeLicense', type: 'association' }
  ];

  static {
    PrimaryTradeLicenseRequirement.PrimaryTradeLicenseRequirementProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          PrimaryTradeLicenseRequirement.columnMap.set(
            property,
            propertyObject
          );
        }
        if (type === 'alias') {
          PrimaryTradeLicenseRequirement.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          PrimaryTradeLicenseRequirement.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(
    PrimaryTradeLicenseRequirementObject: Partial<PrimaryTradeLicenseRequirement>
  ) {
    super();

    PrimaryTradeLicenseRequirement.PrimaryTradeLicenseRequirementProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = PrimaryTradeLicenseRequirementObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  PrimaryTradeId?: number;
  SubNationalDivisionId?: number;
  state?: State;
  isRequired?: boolean;
  lookupURL?: string | null;
  city?: string | null;
  createdAt?: Date;
  updatedAt?: Date;

  PrimaryTrade?: PrimaryTrade;
  SubNationalDivision?: SubNationalDivision;
  Licenses?: License[];
  VendorTrade?: VendorTrade;
  TradeLicenses?: TradeLicense[];
}
